/**
 * 用户 AI 调用记录 /users/$id/llm-logs（旧 views/users/UserLLMLogsView.vue）：
 * 用户信息、总调用次数、调用记录卡片（请求 / 响应默认折叠）、分页
 */
import { useEffect, useState } from 'react'
import { App, Avatar, Button, Card, Empty, Pagination, Spin, Statistic, Typography } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import { getRouteApi, useRouter } from '@tanstack/react-router'
import { PageHeader } from '@/components/PageHeader'
import { LLMLogCard } from '@/features/llm-logs/LLMLogCard'
import { useUserLLMLogs } from '@/features/llm-logs/hooks'
import styles from '@/features/llm-logs/LLMLogsPage.module.css'

const routeApi = getRouteApi('/admin/users/$id/llm-logs')

export function UserLLMLogsPage() {
  const { message } = App.useApp()
  const router = useRouter()
  const userId = Number(routeApi.useParams({ select: (params) => params.id }))
  const [pagination, setPagination] = useState({ page: 1, pageSize: 20 })
  const { data, isFetching, isError, refetch } = useUserLLMLogs(userId, pagination.page, pagination.pageSize)

  useEffect(() => {
    if (isError) message.error('获取AI调用记录失败')
  }, [isError, message])

  const user = data?.user
  const logs = data?.logs ?? []
  const total = data?.total ?? 0

  let content = (
    <div>
      {logs.map((log) => (
        <LLMLogCard key={log.id} log={log} />
      ))}
      {total > 0 && (
        <div className={styles.pagination}>
          <Pagination
            current={pagination.page}
            pageSize={pagination.pageSize}
            total={total}
            showSizeChanger
            showQuickJumper
            showTotal={(count) => `共 ${count} 条记录`}
            pageSizeOptions={[10, 20, 50, 100]}
            onChange={(page, pageSize) => setPagination({ page, pageSize })}
          />
        </div>
      )}
    </div>
  )
  if (isFetching && logs.length === 0) {
    content = (
      <div className={styles.loading}>
        <Spin size="large" />
      </div>
    )
  } else if (logs.length === 0) {
    content = <Empty description="该用户暂无AI调用记录" />
  }

  return (
    <div>
      <PageHeader
        title={`用户 ${user?.username || ''} 的AI调用记录`}
        onBack={() => router.history.back()}
        extra={
          <Button icon={<ReloadOutlined />} loading={isFetching} onClick={() => refetch()}>
            刷新
          </Button>
        }
      />

      {user && (
        <Card variant="borderless" className={styles.stats}>
          <div className={styles.userInfo}>
            <Avatar size={48}>{user.username?.charAt(0).toUpperCase()}</Avatar>
            <div className={styles.userDetails}>
              <Typography.Text strong>{user.username}</Typography.Text>
              <Typography.Text type="secondary">{user.email}</Typography.Text>
            </div>
            <Statistic title="总调用次数" value={total} />
          </div>
        </Card>
      )}

      {content}
    </div>
  )
}
